export default {
    basicdayreport: '/basic/mpp/basicdayreport', // 清除代办事项和通知
    exportdayreport: '/basic/mpp/exportdayreport', // 清除代办事项和通知
    upload: '/api/basic/daily/upload', // 导入名录
    download: '/basic/daily/download', // 模板下载
    targetquery: '/basic/daily/targetquery', // 目标值查询
    targetupdata: '/basic/daily/targetupdata', // 目标值更新
    basicweekreport: '/basic/week/queryreport', // 周报列表查询
    directories: '/basic/daily/directories', // 周报列表查询
    downloadreport: '/basic/week/downloadreport', // 周报列表查询
    startTime: '/basic/daily/starttime', //日周报表限制时间查询
    queryuploadlog: '/basic/daily/queryuploadlog', //名录上传日志查询
    basicMonthreport: '/basic/month/queryReport1', // 月报列表查询
    downloadReportMouth: '/basic/month/downloadReport', // 月报列表查询
};
